import { Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material"
import { format } from "date-fns"
import { ja } from "date-fns/locale"
import React from "react"
import { WeekLongString } from "../../Helper/Week"
import { LessonUnreservable } from "../../Objects/OnlineLesson"

export interface LessonUnreservableItemProps {
    lessonUnreservable: LessonUnreservable
    onEdit?: () => void
    onDelete?: () => void
}

const LessonUnreservableItem: React.FC<LessonUnreservableItemProps> = ({
    lessonUnreservable,
    onEdit,
    onDelete,
}) => {
    return (
        <Card variant="outlined" sx={{
            height: "100%"
        }}>
            <CardContent>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography align="right">[{lessonUnreservable.lurvable_id}]</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>{format(lessonUnreservable.lurvable_date, 'yyyy年MM月dd日 (EE)', {locale: ja})}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography align="right">{(lessonUnreservable.start&&lessonUnreservable.end) ? lessonUnreservable.start.toStringHM()+" 〜 "+lessonUnreservable.end.toStringHM(): ""}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions sx={{
                display: "flex",
                justifyContent: "right"
            }}>
                {onEdit &&
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={()=>{
                            onEdit()
                        }}
                    >変更</Button>
                }
                {onDelete &&
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={()=>{
                            onDelete()
                        }}
                    >削除</Button>
                }
            </CardActions>
        </Card>
    )
}

export default LessonUnreservableItem